import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import 'react-html5-camera-photo/build/css/index.css';
import '../ImagePreview/ImagePreview';
import { useStore } from '../../stores/store';
import PhotoCam from './PhotoCam';
import agent from '../../api/agent';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import { v4 as uuid } from 'uuid';
import { FileUploadInterface } from '../../models/Profile';

interface Props {
  nameData: string;
  workLevelForReceiving?: string;
}
function CameraModal({ nameData, workLevelForReceiving }: Props) {
  const {
    dashboardStore,
    commonStore,
    WorkLevelStore,
    activityStore: { selectedActivity },
  } = useStore();
  const [loading, setLoading] = useState(false);
  const [, setOpen] = useState(false);

  useEffect(() => {
    if (nameData !== 'verify' && nameData !== 'receiving') {
      WorkLevelStore.loadWorkLevelBasedOnItemLevel(selectedActivity?.id);
    }
    // eslint-disable-next-line
  }, [selectedActivity]);

  const finalupload = (e: SyntheticEvent) => {
    e.preventDefault();
    setLoading(true);
    let typeName = '';
    switch (nameData) {
      case 'verify':
        typeName = 'Verify Uploads ';
        break;
      case 'assignuser':
        typeName = 'Assign User Uploads ';
        break;
      default:
        typeName = '';
        break;
    }
    dashboardStore.dashboard.camImageBase64.forEach(async (file: any) => {
      let FileNameChangedata: FileUploadInterface = {
        fileId: '',
        id: '',
        fileName: '',
        url: '',
      };
      let item, workLevel;
      if (commonStore.devEnv) {
        if (nameData === 'verify' || nameData === 'receiving') {
          item = uuid();
        } else {
          item = selectedActivity?.id;
        }
        if (nameData === 'receiving') {
          workLevel = workLevelForReceiving || '';
        } else {
          workLevel = dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
        }
        const response = await agent.Files.localFileUpload(
          file,
          workLevel,
          item,
        );
        const url = response?.data.path.replace(/\\\\/g, '\\');
        FileNameChangedata = {
          fileId: uuid(),
          id: response?.data.id,
          url: url,
          fileName: workLevelForReceiving
            ? workLevelForReceiving
            : typeName.concat(new Date().toLocaleString()),
        };
        if (nameData === 'verify' || nameData === 'receiving') {
          dashboardStore.dashboard.updateLocalFileAPI.push(response.data);
        }
      } else {
        const response = await agent.Files.uploadCameraImage(file);
        FileNameChangedata = {
          fileId: uuid(),
          id: response.data.id,
          url: response.data.url,
          fileName: workLevelForReceiving
            ? workLevelForReceiving
            : typeName.concat(new Date().toLocaleString()),
        };
      }
      dashboardStore.setRegisterUrlResponse([
        ...dashboardStore.dashboard.camImageUrl,
        FileNameChangedata,
      ]);
      setTimeout(() => {
        dashboardStore.setOpenCameraModal(false);
      }, 2000);
    });
    dashboardStore.setcamImageBase64([]);
  };
  const handleCancel = () => {
    dashboardStore.setOpenCameraModal(false);
    dashboardStore.setcamImageBase64([]);
  };

  return (
    <div>
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={dashboardStore.dashboard.openCameraModal}
      >
        <Modal.Header
        //Camera
        >
          {
            (
              userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                ?.IRRCML01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <div>
              <PhotoCam />
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={handleCancel}
            //Cancel
          >
            {
              (
                userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                  ?.IRRCMB01 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
          <Button
            disabled={
              dashboardStore.dashboard.camImageBase64.length > 0 ? false : true
            }
            loading={loading}
            content={
              (
                userLanguage[0].Level3InventoryRecievingRegisterCameraModal
                  ?.IRRCMB02 as any
              )?.[`${commonStore.language.key}`]
            } //"Save"
            //Label={(userLanguage[0].Level3InventoryRecievingRegisterCameraModal?.IRRPMB02 as any)?.[`${commonStore.language.key}`]}//"Save"
            labelPosition="right"
            icon="checkmark"
            onClick={(e) => finalupload(e)}
            positive
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(CameraModal);
